export default (string = '', numOfChars = 100) => {
  return numOfChars < string.length ? string.substring(0, numOfChars).concat('...') : string;
};
